import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { auth as tokenStore, hasValidAccessToken } from '../../api/axios';

interface Props {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Reject expired or malformed tokens up-front so we never flash the protected
  // tree to an unauthenticated user just because some stale JWT sat in
  // localStorage. Stale tokens are cleared so the next login starts clean.
  const tokenOk = hasValidAccessToken();
  if (!tokenOk && tokenStore.getAccessToken()) {
    tokenStore.clear();
  }

  if (loading && tokenOk) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Chargement…
      </div>
    );
  }

  if (!user && !tokenOk) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;
